import "./Loader.css";

export default function Loader(props) {
  return (
    <div
      className={`loader${props.inline ? " loader-inline" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="loader-glow" aria-hidden="true" />

      <div className="loader-stack col">
        <div className="loader-dial">
          <span className="loader-track" aria-hidden="true" />
          <span className="loader-arc" aria-hidden="true" />
          <img
            className="loader-mark"
            src="/logos/multipli-mark.svg"
            alt=""
            aria-hidden="true"
          />
        </div>

        <p className="loader-label">Loading…</p>
      </div>
    </div>
  );
}
